<template>
  <div>
    แลกแต้ม
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
